import React from "react";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaGlobeEurope,
  FaBuilding,
} from "react-icons/fa";

import "./Contact.scss";
import ContactForm from "../../components/Contact/ContactForm";

const Contact = () => {
  return (
    <section className="contact-page">
      <div className="container">
        <div className="contact-header">
          <span className="contact-header__eyebrow">GET IN TOUCH</span>
          <h1>
            Contact <span>FROI</span>
          </h1>
          {/* <p>
            Whether you have a question, want to learn more about our work, or
            are interested in working with us, we would love to hear from you.
          </p> */}
        </div>

        <div className="contact-wrapper">
          {/* LEFT SIDE */}
          <div className="contact-info">
            <div className="contact-info__intro">
              <span className="contact-info__icon">
                <FaGlobeEurope />
              </span>

              <div>
                <h2>Our Offices</h2>
                <p>
                  Connect with our teams across Europe, the Americas, Asia and
                  the Middle East.
                </p>
              </div>
            </div>

            <div className="office-list">
              {/* Europe & Americas */}
              <div className="office-card">
                <div className="office-card__icon">
                  <FaBuilding />
                </div>

                <div className="office-card__content">
                  <h3>Head Office - Europe & Americas</h3>

                  <div className="office-detail">
                    <FaMapMarkerAlt />
                    <span>
                      Marylebone - {/* <br /> */}
                      London, W1W 5PF
                      {/* <br /> */} - United Kingdom
                    </span>
                  </div>

                  <div className="office-detail">
                    <FaEnvelope />
                    <a href="mailto:info@froiglobal.org">info@froiglobal.org</a>
                  </div>
                </div>
              </div>

              {/* Asia */}
              <div className="office-card">
                <div className="office-card__icon">
                  <FaBuilding />
                </div>

                <div className="office-card__content">
                  <h3>Asia</h3>

                  <div className="office-detail">
                    <FaMapMarkerAlt />
                    <span>
                      One Raffles Quay, Singapore - {/* <br /> */}
                      048583
                    </span>
                  </div>

                  <div className="office-detail">
                    <FaEnvelope />
                    <a href="mailto:info@froiglobal.org">info@froiglobal.org</a>
                  </div>
                </div>
              </div>

              {/* Middle East */}
              <div className="office-card">
                <div className="office-card__icon">
                  <FaBuilding />
                </div>

                <div className="office-card__content">
                  <h3>Middle East</h3>

                  <div className="office-detail">
                    <FaMapMarkerAlt />
                    <span>
                      ICD Brookfield Place
                      <br />
                      Dubai, United Arab Emirates
                    </span>
                  </div>

                  <div className="office-detail">
                    <FaEnvelope />
                    <a href="mailto:ME@froiglobal.org">ME@froiglobal.org</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
